const UPDATE_EMBED_CAPTIONS_COLOR = (state, payload) => {
  state.embed.captionsColor = payload
}

const UPDATE_EMBED_CAPTIONS_BACKGROUND_COLOR = (state, payload) => {
  state.embed.captionsBackgroundColor = payload
}

const UPDATE_INTRO_KEY = (state, payload) => {
  state.intro.key = payload
}

const UPDATE_INTRO_TYPE = (state, payload) => {
  state.intro.type = payload
}

const UPDATE_INTRO_STATUS = (state, payload) => {
  state.intro.status = payload
}

const UPDATE_IS_ADBLOCK_ENABLED = (state, payload) => {
  state.isAdBlockEnabled = payload
}

const UPDATE_WARNING_CARDS_LOADED = (state, payload) => {
  state.warnings.isCardsLoaded = payload
}

const UPDATE_ACTION_BUTTON_TYPE = (state, payload) => {
  state.warnings.showActionButtonType = payload
}

const UPDATE_VIDEO_TIMELINE_ITEMS = (state, payload) => {
  state.timelineItems = payload
}

export {
  UPDATE_EMBED_CAPTIONS_COLOR,
  UPDATE_EMBED_CAPTIONS_BACKGROUND_COLOR,
  UPDATE_INTRO_KEY,
  UPDATE_INTRO_TYPE,
  UPDATE_INTRO_STATUS,
  UPDATE_IS_ADBLOCK_ENABLED,
  UPDATE_WARNING_CARDS_LOADED,
  UPDATE_ACTION_BUTTON_TYPE,
  UPDATE_VIDEO_TIMELINE_ITEMS,
}
